const getCartTotalsTitle = (numberOfItems, intl, singularLabelKey, pluralLabelKey)=>{
    const labelKey = numberOfItems === 1 && intl.hasLabel(singularLabelKey) ? singularLabelKey : pluralLabelKey;
    return intl.getFormattedLabel(labelKey, {
        labelData: {
            numberOfItems
        }
    });
};

export { getCartTotalsTitle };
//# sourceMappingURL=get-cart-totals-title.js.map
